// Kullanıcı kartlarındaki arama / sohbet aksiyonları (Keşfet kartlarıyla aynı davranış).
// Kural: AI -> sesli; cameraOn true -> görüntülü; cameraOn false ve voiceOn true -> sesli; ikisi de kapalı -> arama yok.
// Kullanan bileşen callSource (data/prop/computed) tanımlarsa arama istatistiğinde o kaynak kullanılır.
export default {
  methods: {
    getCallMode(user) {
      if (!user) return null
      if (user.is_ai || user.isAi) return 'voice'
      const profile = user.profile || {}
      const pick = (...values) => values.find(v => v !== undefined && v !== null)
      const cameraOn = pick(user.camera_on, user.cameraOn, profile.cameraOn)
      const voiceOn = pick(user.voice_on, user.voiceOn, profile.voiceOn)
      if (cameraOn === undefined && voiceOn === undefined) return 'video'
      if (cameraOn) return 'video'
      if (voiceOn) return 'voice'
      return null
    },
    call(user) {
      if (!user) return
      // AI kullanıcılar profil sayfasındaki gibi LiveKit sesli görüşme akışıyla aranır
      // (eski Agora akışı AI kullanıcılar için çalışmıyordu)
      if (user.is_ai || user.isAi) {
        this.$root.$emit('ai-voice-call:start', {
          ...user,
          uuid: user.uuid || user.id,
          id: user.uuid || user.id,
          user_name: user.user_name || user.userName,
          image: user.profile_photo_url,
          profile: { image: user.profile_photo_url },
        })
        return
      }
      this.$store.dispatch('app/setModalCallType', 'audio')
      this.$store.dispatch('app/setCallDetails', {
        callSource: this.callSource || 'discovery_grid',
        userOrder: 0,
      })
      this.$store.dispatch('app/setModalCall', false)
      setTimeout(() => {
        this.$store.dispatch('app/setModalCallUser', {
          ...user,
          id: user.uuid || user.id,
          userName: user.user_name || user.userName,
          profile: {
            image: user.profile_photo_url,
            country: user.country,
            onlineStatus: user.is_connected ? 'online' : 'offline',
          },
        })
        this.$store.dispatch('app/setModalCall', true)
      }, 33)
    },
    videoCall(user) {
      if (!user) return
      this.$store.dispatch('app/setModalCallType', 'video')
      this.$store.dispatch('app/setCallDetails', {
        callSource: this.callSource || 'discovery_grid',
        userOrder: 0,
      })
      this.$store.dispatch('app/setModalCall', false)
      setTimeout(() => {
        this.$store.dispatch('app/setModalCallUser', {
          ...user,
          id: user.uuid || user.id,
          userName: user.user_name || user.userName,
          profile: {
            image: user.profile_photo_url,
            country: user.country,
            onlineStatus: user.is_connected ? 'online' : 'offline',
          },
        })
        this.$store.dispatch('app/setModalCall', true)
      }, 33)
    },
    chat(user) {
      if (!user) return
      this.$router.push({
        name: 'chat',
        params: { userId: user.uuid || user.id },
      })
    },
  },
}
